import { render, staticRenderFns } from "./pay_automatic.vue?vue&type=template&id=e4108948&scoped=true&"
import script from "./pay_automatic.vue?vue&type=script&lang=js&"
export * from "./pay_automatic.vue?vue&type=script&lang=js&"
import style0 from "./pay_automatic.vue?vue&type=style&index=0&id=e4108948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4108948",
  null
  
)

export default component.exports